import { TAuthority } from '@/types';

/**
 * ログインユーザの認可情報に必須認可が含まれているか判定する関数
 * @param {object} { authority: 必須認可, userAuthorities: ログインユーザの認可情報 }
 * @returns {boolean} 判定値
 */
export const hasAuthority = ({
  authority,
  userAuthorities,
}: {
  authority?: TAuthority | TAuthority[];
  userAuthorities?: TAuthority[];
}): boolean => {
  if (!userAuthorities) return false;
  if (!authority || authority.length === 0) return true;

  if (typeof authority === 'string') {
    return userAuthorities.includes(authority);
  }

  return authority.map((value) => userAuthorities.includes(value))
    .includes(true);
};
